import ArchivesOverviewView from '@/components/routes/archives/ArchivesOverviewView'

const archivesRoutes = [
  {
    name: 'archives',
    path: '/archives',
    component: ArchivesOverviewView,
    props: true
  }
]

export default archivesRoutes
